import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { SliderAutoplay, updateActiveTab, startLoaderAnimation, updateLoaderProgress } from './global.js';

// Initialize all slider blocks on the page
function initSliderBlocks() {
    const sliderBlocks = document.querySelectorAll('.js-sliderBlock');
    
    sliderBlocks.forEach((sliderBlock, blockIndex) => {
        const slider = sliderBlock.querySelector('.js-slider');
        const navigation = sliderBlock.querySelector('.js-sliderNav');
        const navItems = navigation.querySelectorAll('li');
        const loaders = sliderBlock.querySelectorAll('.js-sliderLoader');
        
        if (!slider || !navigation) return;
        
        let currentActiveIndex = 0;
        const totalSlides = navItems.length;
        
        // Create autoplay instance
        const autoplay = new SliderAutoplay();
        
        function handleSlideChange() {
            if (swiper.activeIndex < totalSlides - 1) {
                swiper.slideNext();
            } else {
                swiper.slideTo(0);
            }
        }
        
        function handleProgress(progressPercent) {
            updateLoaderProgress(loaders[currentActiveIndex], progressPercent);
        }
        
        function startAutoplayForSlide(slideIndex) {
            currentActiveIndex = slideIndex;
            startLoaderAnimation(loaders, slideIndex);
            autoplay.start(slideIndex, totalSlides, handleProgress, handleSlideChange);
        }
        
        // Create Swiper instance
        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 800,
            allowTouchMove: false,
            loop: false,
            on: {
                init: function() {
                    updateActiveTab(navItems, 0);
                    startAutoplayForSlide(0);
                },
                slideChange: function() {
                    const activeIndex = this.activeIndex;
                    updateActiveTab(navItems, activeIndex);
                    startAutoplayForSlide(activeIndex);
                }
            }
        });
        
        // Add click handlers to navigation tabs
        navItems.forEach((navItem, index) => {
            navItem.addEventListener('click', () => {
                // Stop current autoplay
                autoplay.stop();
                
                // Change to the clicked slide
                swiper.slideTo(index);
                
                // Start autoplay for new slide
                startAutoplayForSlide(index);
            });
        });
        
        // Add manual mouse enter/leave handling for pauseOnMouseEnter
        slider.addEventListener('mouseenter', () => {
            autoplay.pause();
        });
        
        slider.addEventListener('mouseleave', () => {
            autoplay.resume();
        });
    });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initSliderBlocks);
